import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-m-4" }
const _hoisted_2 = { class: "p-fluid p-col-12 p-md-12 p-mt-4" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = {
  for: "value",
  class: "kn-material-input-label"
}
const _hoisted_5 = { class: "p-fluid p-col-12 p-md-12 p-mt-4" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = {
  for: "name",
  class: "kn-material-input-label"
}
const _hoisted_8 = {
  key: 0,
  class: "p-error"
}
const _hoisted_9 = { class: "p-col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.selectedParameter.type === 'cell')
      ? (_openBlock(), _createBlock(_component_Message, {
          key: 0,
          class: "p-m-4",
          severity: "info",
          closable: false,
          style: _ctx.olapCrossNavigationDefinitionDialogDescriptor.styles.message
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.olap.crossNavigationDefinition.hint')), 1)
          ]),
          _: 1
        }, 8, ["style"]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_2, [
      _createVNode("span", _hoisted_3, [
        _createVNode(_component_InputText, {
          id: "value",
          class: "kn-material-input",
          modelValue: _ctx.selectedParameter.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedParameter.value = $event)),
          modelModifiers: { trim: true }
        }, null, 8, ["modelValue"]),
        _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('common.value')), 1)
      ])
    ]),
    _createVNode(_component_Button, {
      id: "olap-select-from-table-button",
      class: "kn-button kn-button--primary p-mt-4",
      onClick: _ctx.selectFromTable
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.olap.crossNavigationDefinition.selectFromTable')), 1)
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode("div", _hoisted_5, [
      _createVNode("span", _hoisted_6, [
        _createVNode(_component_InputText, {
          id: "name",
          class: ["kn-material-input", {
                        'p-invalid': !_ctx.selectedParameter.name && _ctx.nameTouched
                    }],
          modelValue: _ctx.selectedParameter.name,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedParameter.name = $event)),
          modelModifiers: { trim: true },
          onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.nameTouched = true))
        }, null, 8, ["modelValue", "class"]),
        _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('documentExecution.olap.crossNavigationDefinition.parameterName')) + " *", 1)
      ]),
      (!_ctx.selectedParameter.name && _ctx.nameTouched)
        ? (_openBlock(), _createBlock("div", _hoisted_8, [
            _createVNode("small", _hoisted_9, _toDisplayString(_ctx.$t('common.validation.required', { fieldName: _ctx.$t('documentExecution.olap.crossNavigationDefinition.parameterName') })), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}